<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1919256" style="color: #82a339"><b>FRENCH ONION SOUP</b></p>
<p class="ext" id="d7e1919756"><b><i>Onions, slowly cooked until deep brown and caramelized, give this classic its distinctive flavor. Great for a party, this recipe is easily doubled; simply cook the onions in two skillets.</i></b></p>
<p class="h4" id="d7e1921556" style="color: #496210"><b>Prep: 10 minutes Cook/Bake: 2 hours</b></p>
<p class="ul" id="d7e1922056">4 tablespoons butter or margarine</p>
<p class="ul" id="d7e1922356">6 medium onions, thinly sliced</p>
<p class="ul" id="d7e1922656">¼ teaspoon salt</p>
<p class="ul" id="d7e1923556">4 cups water</p>
<p class="ul" id="d7e1924256">1 can (14½ ounces) beef broth or <br/> 1¾ cups Brown Beef Stock</p>
<p class="ul" id="d7e1926556">¼ teaspoon dried thyme</p>
<p class="ul" id="d7e1927456">4 diagonal slices (½-inch thick) French bread</p>
<p class="ul" id="d7e1928656">4 ounces Gruyère or Swiss cheese, shredded (1 cup)</p>
<p class="pub" id="d7e1929456" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In nonstick 12-inch skillet, melt butter over medium-low heat. Add onions and salt and cook, stirring occasionally, until onions are very tender and begin to caramelize, about 45 minutes. Reduce heat to low and cook, stirring frequently, until onions are deep golden brown, about 15 minutes longer.</p>
<p class="ser"><img alt="9781618371621_0056_001" src="Images/9781618371621_0056_001.jpg" style="max-width:100%;"/></p>
<p class="pub" id="d7e1933556"><span style="color: #c15b49"><b>2.</b></span> Transfer onions to 5-quart Dutch oven. Add ½ cup water to same skillet and heat to boiling, stirring until browned bits are loosened from bottom of skillet. Add to onions in Dutch oven. Add remaining 3½ cups water, broth, and thyme to onions and heat to boiling over high heat. Reduce heat and simmer 30 minutes.</p>
<p class="pub" id="d7e1937556"><span style="color: #c15b49"><b>3.</b></span> Preheat oven to 450°F. Arrange bread slices on cookie sheet and bake until lightly toasted, about 5 minutes. Place four ovenproof bowls in jelly-roll pan for easier handling. Spoon soup evenly into bowls and top with toasted bread, slightly pressing bread into soup. Sprinkle Gruyère evenly on top. Bake until cheese has melted and begins to brown, 12 to 15 minutes. Makes about 5 cups or 4 first-course servings.</p>
<p class="ntx" id="d7e1941456">Each serving: About 402 calories, 15g protein, 37g carbohydrate, 22g total fat (13g saturated), 64mg cholesterol, 887mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c53_r1.vue?45b1d7fe